import type { BreadcrumbBlockConfig } from '@lighthouse/core'

export const generateBreadcrumbBlock = (mainBreakPoint: string): BreadcrumbBlockConfig => {
    return {
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                }
            }
        },
        breakPoints: []
    }
}
